
import store from '@/store'
// 权限检查函数
function checkPermission(el, binding) {
  const { value } = binding
  
  // 获取用户权限列表，这里假设从Vuex store中获取

  const {roles=[]} = store.getters


  if (value && value instanceof Array && value.length > 0) {
    const requiredPermissions = value
    const hasPermission = roles.some(permission => {
      return requiredPermissions.includes(permission)
    })
     //  console.log(' checkPermission', value, roles, hasPermission)
    // console.log('hasPermission', hasPermission)
    if (!hasPermission) {
      // 如果没有权限，则移除元素
      el.parentNode && el.parentNode.removeChild(el)
    }
  } else {
    throw new Error(`需要指定权限数组，如 v-permission="['admin']"`)
  }
}

export default {
  inserted(el, binding) {
    checkPermission(el, binding)
  },
  update(el, binding) {
    checkPermission(el, binding)
  }
}